export default __webpack_public_path__ + "static/TCC Technoloy_logo-aa1dc8e3234612f5cb794110aad2f90b.png";